import React from 'react';
import { Truck, MapPin, Clock, Package, AlertCircle, Phone } from 'lucide-react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import './PolicyPage.css';

const ShippingPolicyPage = () => {
  return (
    <>
      <Navbar />
      <div className="policy-page">

        <section className="policy-hero">
          <div className="container">
            <div className="policy-hero-badge"><Truck size={14} /> Shipping Policy</div>
            <h1 className="policy-hero-title">Shipping & <span>Delivery</span></h1>
            <p className="policy-hero-sub">Everything you need to know about how we get your fresh seafood to your door.</p>
          </div>
        </section>

        <section className="policy-body">
          <div className="container">
            <div className="policy-highlights">
              <div className="policy-highlight-card">
                <div className="policy-highlight-icon"><Truck size={24} /></div>
                <h3>Free Delivery</h3>
                <p>Greater Accra region</p>
              </div>
              <div className="policy-highlight-card">
                <div className="policy-highlight-icon"><Clock size={24} /></div>
                <h3>1–7 Working Days</h3>
                <p>Standard delivery time</p>
              </div>
              <div className="policy-highlight-card">
                <div className="policy-highlight-icon"><MapPin size={24} /></div>
                <h3>Nationwide</h3>
                <p>Delivery across Ghana</p>
              </div>
              <div className="policy-highlight-card">
                <div className="policy-highlight-icon"><Package size={24} /></div>
                <h3>Fresh Packaging</h3>
                <p>Temperature-controlled</p>
              </div>
            </div>

            <div className="policy-content">
              <div className="policy-section">
                <h2><MapPin size={20} /> Delivery Areas</h2>
                <p>Aurora delivers across Ghana. Delivery costs depend on your location:</p>
                <div className="policy-table">
                  <div className="policy-table-row header">
                    <span>Zone</span>
                    <span>Area</span>
                    <span>Cost</span>
                    <span>Timeframe</span>
                  </div>
                  <div className="policy-table-row">
                    <span>Zone 1</span>
                    <span>Greater Accra Region</span>
                    <span className="policy-free">FREE</span>
                    <span>1–3 working days</span>
                  </div>
                  <div className="policy-table-row">
                    <span>Zone 2</span>
                    <span>Outside Greater Accra</span>
                    <span>Paid by customer at reception</span>
                    <span>3–7 working days</span>
                  </div>
                </div>
              </div>

              <div className="policy-section">
                <h2><Clock size={20} /> Delivery Timeframes</h2>
                <p>Orders are processed and dispatched based on product availability and order placement time. Delivery times are estimates and may vary due to:</p>
                <ul>
                  <li>High order volumes during peak seasons</li>
                  <li>Public holidays and weekends</li>
                  <li>Remote delivery locations</li>
                  <li>Adverse weather conditions</li>
                </ul>
                <p>You will receive email and SMS notifications at each stage of your delivery.</p>
              </div>

              <div className="policy-section">
                <h2><Package size={20} /> Packaging</h2>
                <p>All seafood products are carefully packed to maintain freshness during transit. We use:</p>
                <ul>
                  <li>Temperature-controlled packaging for fresh fish</li>
                  <li>Sealed, food-grade containers to prevent contamination</li>
                  <li>Insulated packaging for longer delivery distances</li>
                </ul>
              </div>

              <div className="policy-section">
                <h2><AlertCircle size={20} /> Receiving Your Order</h2>
                <p>When your order arrives, please:</p>
                <ul>
                  <li>Inspect the package for any damage before signing</li>
                  <li>Check that all items match your order</li>
                  <li>Refrigerate products immediately upon receipt</li>
                </ul>
                <p><strong>Note:</strong> Receipt of the products represents your acceptance that they arrived in good condition. If you notice any issues, contact us within 2 hours of delivery with photos.</p>
              </div>

              <div className="policy-section">
                <h2><Phone size={20} /> Delivery Support</h2>
                <p>For delivery inquiries, contact us:</p>
                <div className="policy-contact-grid">
                  <a href="mailto:orders@auroragh.com" className="policy-contact-item">
                    <strong>Email</strong>
                    <span>orders@auroragh.com</span>
                  </a>
                  <a href="tel:0550866710" className="policy-contact-item">
                    <strong>Phone</strong>
                    <span>0550866710</span>
                  </a>
                </div>
                <p className="policy-hours">Available Monday – Friday, 09:00 – 17:00 GMT</p>
              </div>
            </div>
          </div>
        </section>

      </div>
      <Footer />
    </>
  );
};

export default ShippingPolicyPage;